import React from 'react'
import { Field } from 'redux-form'
import { FormControlLabel, Switch } from '@material-ui/core'
import { renderTextField } from '../../../Forms/fieldRenderers'

function CamposConfiguracionPesado (props) {
  const { rolAutorizado, balanza } = props

  return (
    <>
      <Field
        className='campos-configuracion-destare'
        name='urlBruto'
        type='text'
        label='URL de lectura de peso bruto'
        component={renderTextField}
        placeholder='http://localhost:12000'
      />
      <Field
        className='campos-configuracion-destare'
        name='pesoMaximo'
        type='text'
        label='Peso máximo en bruto'
        component={renderTextField}
        placeholder='55555'
      />
      <Field
        className='campos-configuracion-destare'
        name='pesoMaximoAdvertencia'
        type='text'
        label='Peso máximo de advertencia en bruto'
        component={renderTextField}
        placeholder='55555'
      />
      <Field
        className='campos-configuracion-destare'
        name='pesoMinimo'
        type='text'
        label='Peso mínimo en bruto'
        component={renderTextField}
        placeholder='55555'
      />
      <Field
        className='campos-configuracion-destare'
        name='pesoMinimoAdvertencia'
        type='text'
        label='Peso mínimo de advertencia en bruto'
        component={renderTextField}
        placeholder='55555'
      />

      <FormControlLabel
        control={
          <Switch
            color='primary'
            name='muleto'
            onChange={props.updateBalanzaDeBruto}
            checked={balanza === 'MULETO'}
            disabled={!rolAutorizado}
          />
        }
        label='Pesar en balanza muleto'
      />

    </>
  )
}

export default CamposConfiguracionPesado
